/**
 * Domain utilities for schedules feature guard
 */

/**
 * Check if the current domain requires schedules feature validation
 * Returns true for: new.my.* domains and localhost:4200
 */
export function shouldCheckSchedulesFeature(): boolean {
	const hostname = window.location.hostname

	// Check for localhost
	if (hostname === 'localhost') {
		return true
	}

	// Check for new.my.* domains (new.my.brandtrack.dev, new.my.brandtrack.ai, etc.)
	if (hostname.startsWith('new.my.')) {
		return true
	}

	return false
}

/**
 * Get the redirect URL by removing "new." prefix from hostname
 * For localhost:4200, changes port to 4201
 * Preserves the current protocol (http/https)
 */
export function getRedirectUrl(): string {
	const protocol = window.location.protocol
	const hostname = window.location.hostname
	const port = window.location.port

	// Handle localhost special case
	if (hostname === 'localhost') {
		return `${protocol}//localhost:4201`
	}

	// Handle new.my.* domains - remove "new." prefix
	if (hostname.startsWith('new.my.')) {
		const newHostname = hostname.replace('new.', '')
		// Include port if it exists and is not default (80/443)
		const portSuffix = port && port !== '80' && port !== '443' ? `:${port}` : ''
		return `${protocol}//${newHostname}${portSuffix}`
	}

	// Fallback - shouldn't happen if shouldCheckSchedulesFeature is used correctly
	return `${protocol}//${hostname}`
}

/**
 * Check if we're already on the redirect target URL
 * Prevents redirect loops
 */
export function isAlreadyOnRedirectTarget(): boolean {
	const currentUrl = window.location.href.split('?')[0] // Remove query params
	const redirectUrl = getRedirectUrl()

	// If redirect URL would be the same as current, we're already there
	return currentUrl.startsWith(redirectUrl)
}
